import { FlowGraphBlock } from "../../flowGraphBlock.js";
/**
 * @experimental
 * The base block for all binary operation blocks. Receives an input of type
 * LeftT, one of type RightT, and outputs a value of type ResultT.
 */
export class FlowGraphBinaryOperationBlock extends FlowGraphBlock {
    constructor(leftRichType, rightRichType, resultRichType, _operation) {
        super();
        this._operation = _operation;
        this.leftInput = this._registerDataInput("leftInput", leftRichType);
        this.rightInput = this._registerDataInput("rightInput", rightRichType);
        this.output = this._registerDataOutput("Output", resultRichType);
    }
    _updateOutputs(_context) {
        this.output.setValue(this._operation(this.leftInput.getValue(_context), this.rightInput.getValue(_context)), _context);
    }
}
//# sourceMappingURL=flowGraphBinaryOperationBlock.js.map